module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_salado.d61def7e.png";